<template>
    <v-layout column align-center justify-center class="empty-state">
        <img height="150" src="/static/LTN_Empty_State.png"/>

        <h2 class="font-weight-bold title">{{message}}</h2>

    </v-layout>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    message: {
      required: true,
      type: String,
    },
  }
};
</script>

<style scoped>
.empty-state{
    min-height: 300px;
}
.title {
    padding: 24px;
    color: #b3b3b3;
}
</style>



// WEBPACK FOOTER //
// src/components/EmptyState.vue